import React from "react";
import { useParams } from "react-router-dom";
import OrderConfirmation from "../placeOrder/OrderConfirmation";

// Customer Order Request detail reuses the real order/quote detail UI
// (OrderConfirmation) in a guarded read-only "approval" mode: all fields are
// read-only, the order/quote mutation actions are hidden, and Approve / Reject
// are shown instead. The `key` remounts the page when the route params change
// (mirrors OrderConfirmationRoute in customerRoute.js).
const CustomerOrderRequestDetail = () => {
	const { contactInfoId, unitId, jobNum } = useParams();
	return <OrderConfirmation key={`${contactInfoId}-${unitId}-${jobNum}`} isOrderRequestView={true} />;
};

export default CustomerOrderRequestDetail;
